import { formatKennitala } from 'helpers';
import type { Translate } from 'providers/ApplicationContext';
import type { ProcessesResponse } from 'types';

type AdminDrawerHeaderProps = {
	busy: boolean;
	onClose: () => void;
	row: ProcessesResponse;
	t: Translate;
};

export function AdminDrawerHeader({ busy, onClose, row, t }: Readonly<AdminDrawerHeaderProps>) {
	return (
		<div className="admin-drawer-header">
			<div>
				<div className="admin-drawer-header__subtitle">{t('update_process')}</div>
				<div className="admin-drawer-header__name">{row.fullNameInitiator}</div>
				<div className="admin-drawer-header__meta">
					{formatKennitala(row.kennitala)} · {t(`flow-type-${row.flowType}`)}
				</div>
				<p>
					<button
						className="admin-drawer-guid"
						onClick={() => {
							navigator.clipboard.writeText(row.agreementProcessId);
						}}
						title={t('copy_to_clipboard')}
						type="button"
					>
						{row.agreementProcessId} ⧉
					</button>
				</p>
			</div>
			<button className="admin-drawer-close" disabled={busy} onClick={onClose} type="button">
				×
			</button>
		</div>
	);
}
